/**
 * Identifies the type of a form.
 * Checks for specific classes, attributes, or IDs to determine the form type.
 * @param {HTMLFormElement} form - The form element to identify.
 * @returns {string} The type of the form.
 */
function getFormType(form) {
	if (form.classList.contains('gform_wrapper')) {
		return 'gravity-forms';
	} if (form.classList.contains('hs-form')) {
		return 'hubspot';
	} if (form.id === 'loginform' || form.id === 'wp-login-form') {
		return 'log-in';
	} if (form.classList.contains('search-form') || form.querySelector('input[type="search"]')) {
		return 'search';
	}
	return 'other';
}

export default getFormType;
